import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from '../locale';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    returnEmptyString: false,
    resources: (resources || []).reduce((all, { key, lng }) => {
      all[key] = lng;
      return all;
    }, {}),
    lng: 'en',
    // no explicit separator character used to separate namespaces or keys in the translation keys
    // nsSeparator default value: ':', keySeparator default value: '.'
    keySeparator: false,
    nsSeparator: false,
    fallbackLng: {
      ...(resources || []).reduce((all, { key, fallback }) => {
        all[key] = fallback;
        return all;
      }, {}),
      default: ['en']
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });
